const STORAGE_KEY = 'arrival-booking-clerk-email-link'

export type ClerkEmailLinkQuery = {
  status: string | null
  sessionId: string | null
}

export function parseClerkEmailLinkQuery(search: string): ClerkEmailLinkQuery {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
  return {
    status: params.get('__clerk_status'),
    sessionId: params.get('__clerk_created_session'),
  }
}

export function readClerkEmailLinkQuery(): ClerkEmailLinkQuery | null {
  if (typeof window === 'undefined') {
    return null
  }
  const raw = sessionStorage.getItem(STORAGE_KEY)
  if (!raw) {
    return null
  }
  try {
    const parsed = JSON.parse(raw) as ClerkEmailLinkQuery
    if (!parsed || typeof parsed !== 'object') {
      return null
    }
    return {
      status: typeof parsed.status === 'string' ? parsed.status : null,
      sessionId: typeof parsed.sessionId === 'string' ? parsed.sessionId : null,
    }
  } catch {
    return null
  }
}

export function clearClerkEmailLinkQuery(): void {
  if (typeof window === 'undefined') {
    return
  }
  sessionStorage.removeItem(STORAGE_KEY)
}

/** Snapshot Clerk email-link query before handshake/load strips `__clerk_*` params. */
export function persistClerkEmailLinkQueryFromLocation(): ClerkEmailLinkQuery | null {
  if (typeof window === 'undefined') {
    return null
  }
  const parsed = parseClerkEmailLinkQuery(window.location.search)
  if (!parsed.status && !parsed.sessionId) {
    return readClerkEmailLinkQuery()
  }
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(parsed))
  return parsed
}

export function clerkEmailLinkFailureStatus(status: string | null): 'expired' | 'client_mismatch' | 'failed' | null {
  if (status === 'expired') {
    return 'expired'
  }
  if (status === 'client_mismatch') {
    return 'client_mismatch'
  }
  if (status === 'failed') {
    return 'failed'
  }
  return null
}
